import McTabTable from './McTabTable';

export default McTabTable;
